"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDiscussionHost = void 0;
/**
 * Returns whether or not a participant is the host of a discussion.
 */
function isDiscussionHost(discussion, participantId) {
    return discussion.ownerId === participantId;
}
exports.isDiscussionHost = isDiscussionHost;
//# sourceMappingURL=isDiscussionHost.js.map